/* NICOCHILL LP — interactive enhancements */

(function () {
  'use strict';

  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  // ----- Reveal-on-scroll -----
  function setupReveals() {
    const targets = $$([
      '.nc-card',
      '.nc-stat',
      '.nc-voice',
      '.nc-flow__step',
      '.nc-plan',
      '.nc-faq__item',
      '.nc-fv__content',
      '.nc-h2',
      '.nc-giant',
      '.nc-cta__copy',
      '.nc-cta__buttons',
      '.nc-warn',
    ].join(','));

    if (!('IntersectionObserver' in window)) {
      targets.forEach(t => t.classList.add('nc-revealed'));
      return;
    }

    targets.forEach(t => t.classList.add('nc-reveal'));

    const obs = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add('nc-revealed');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });

    targets.forEach(t => obs.observe(t));
  }

  // ----- FV parallax (giant text のみ — product は CSS float に任せる) -----
  function setupHeroParallax() {
    const giant = document.querySelector('.nc-fv__giant');
    const bg = document.querySelector('.nc-fv__bg img');
    if (!giant && !bg) return;

    let raf = false;
    function update() {
      const sc = window.scrollY;
      if (sc < window.innerHeight) {
        if (giant) {
          giant.style.transform = `translateY(${sc * 0.32}px)`;
          giant.style.opacity = String(Math.max(0, 1 - sc / (window.innerHeight * 0.7)));
        }
        if (bg) {
          bg.style.transform = `scale(1.05) translateY(${sc * 0.08}px)`;
        }
      }
      raf = false;
    }
    window.addEventListener('scroll', () => {
      if (!raf) {
        window.requestAnimationFrame(update);
        raf = true;
      }
    }, { passive: true });
  }

  // ----- Smooth anchor scroll with header offset -----
  function setupSmoothAnchors() {
    document.addEventListener('click', (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const id = a.getAttribute('href').slice(1);
      if (!id) return;
      const el = document.getElementById(id);
      if (!el) return;
      e.preventDefault();
      const headerH = document.querySelector('.nc-header')?.offsetHeight ?? 60;
      const top = el.getBoundingClientRect().top + window.pageYOffset - headerH - 12;
      window.scrollTo({ top, behavior: 'smooth' });
    });
  }

  // ----- Scroll progress bar -----
  function setupScrollProgress() {
    const bar = document.createElement('div');
    bar.className = 'nc-progress';
    document.body.appendChild(bar);
    let raf = false;
    function update() {
      const max = document.documentElement.scrollHeight - window.innerHeight;
      const pct = max > 0 ? (window.scrollY / max) * 100 : 0;
      bar.style.transform = `scaleX(${pct / 100})`;
      raf = false;
    }
    window.addEventListener('scroll', () => {
      if (!raf) { window.requestAnimationFrame(update); raf = true; }
    }, { passive: true });
  }

  // ----- Init -----
  function init() {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    setupSmoothAnchors();
    setupScrollProgress();
    if (reduce) {
      $$('.nc-reveal').forEach(t => t.classList.add('nc-revealed'));
      return;
    }
    setupReveals();
    setupHeroParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
